import $ from 'jquery';

function setCountryCode() {
  const countryCode = window.dataLayer && window.dataLayer.length > 0 ? window.dataLayer[0].country : '';
  $("input[name='country_code']").val(countryCode);
}

function fillCountryInput() {
  setCountryCode();
  $(document).on('enquire-form:opened', setCountryCode);
}

export default fillCountryInput;
